import request from '@/utils/request'

// 电子面单账号列表
// 查询电子面单管理列表的接口
export function queryExpressListApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/basicEcom/queryExpressList',
    method: 'post',
    data
  });
}
// 解绑普通电子面单k码
export function unBindNormalCustomerCodeApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/webCustomer/unbindCustomCode',
    method: 'post',
    data
  });
}
// 中通电子面单解绑
export function unbindZTOUserApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/expressUser/unbindUser',
    method: 'post',
    data
  });
}
// 检查圆准达服务详情
export function queryApplyInfoApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/arriveTime/lastApplyInfo',
    method: 'post',
    data
  });
}
// 申请圆准达服务
export function applyYzdServiceApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/arriveTime/apply',
    method: 'post',
    data
  });
}
// 中通电子面单修改密钥
export function changeSecretKeyApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/expressUser/changeSecretKey',
    method: 'post',
    data
  });
}
//K码申请List查询
export function queryKApplyListApi(data) {
  return request({
    baseURL:'/steward/core/',
    url: '/kCodeApply/queryKApplyList',
    method: 'post',
    data
  });
}
//查询主数据网点信息
export function queryOrgInfoApi(data) {
  return request({
    baseURL:'/steward/core/',
    url: '/kCodeApply/queryOrgInfo',
    method: 'get',
    params: {searchValue:data},
  });
}
//查询GIS网点信息
export function queryOrgDetailApi(data) {
  return request({
    baseURL:'/steward/core/',
    url: '/kCodeApply/queryOrgDetail',
    method: 'get',
    params: {orgCode:data},
  });
}
//模糊查询获取企业名称
export function queryCompanyNameApi(data) {
  return request({
    baseURL:'/steward/core/',
    url: '/kCodeApply/queryCompanyName',
    method: 'get',
    params: {searchValue:data},
  });
}
//查询企业工商信息
export function queryCompanyInfoApi(data) {
  return request({
    baseURL:'/steward/core/',
    url: '/kCodeApply/queryCompanyInfo',
    method: 'get',
    params: {searchValue:data},
  });
}
//查询产品/托寄物类型
export function queryProductTypeApi(data) {
  return request({
    baseURL:'/steward/core/',
    url: '/kCodeApply/queryProductType',
    method: 'get',
    params: {parentCode:data},
  });
}
//查询产品/托寄物类型
export function uploadIdCardImgApi(data) {
  return request({
    baseURL:'/steward/core/',
    url: '/kCodeApply/uploadIdCardImg',
    method: 'post',
    data
  });
}
//身份证识别接口
export function newRecognizeIdCardApi(data) {
  return request({
    baseURL:'/steward/core/',
    url: '/kCodeApply/newRecognizeIdCard',
    method: 'get',
    params: {imgPath:data},
  });
}
//K码申请新增
export function insertKCodeApplyApi(data) {
  return request({
    baseURL:'/steward/core/',
    url: '/kCodeApply/insertKCodeApply',
    method: 'post',
    data
  });
}
//K码申请记录明细
export function queryKApplyDetailApi(data, type) {
  return request({
    baseURL:'/steward/core/',
    url: '/kCodeApply/queryKApplyDetail?operateType=' + type,
    method: 'post',
    data
  });
}
//K码申请更新
export function updateKCodeApplyApi(data) {
  return request({
    baseURL:'/steward/core/',
    url: '/kCodeApply/updateKCodeApply',
    method: 'post',
    data
  });
}
//实名制校验
export function checkRealNameApi(data,type) {
  let params = {};
  if(type=='FA'){
    params = {name:data.certificatesName,idCard:data.certificatesNo}
  }else{
    params = {name:data.replaceCertificatesName,idCard:data.replaceCertificatesNo}
  }
  return request({
    baseURL:'/steward/core/',
    url: '/kCodeApply/checkRealName',
    method: 'get',
    params: params,
  });
}
// 申请同城件
export function applyTcjInfoApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/customerLocal/apply',
    method: 'post',
    data
  });
}
// 查询申请同城件历史记录
export function queryApplyTcjRecordApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/customerLocal/queryAllApplyRecord',
    method: 'post',
    data
  });
}
// 修改同城件时--查询最新同城件申请详情，用于编辑回显
export function queryTcjApplyInfoApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/customerLocal/lastApplyInfo',
    method: 'post',
    data
  });
}
// 腾讯电子面单查询余额
export function wxNetsiteApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/basicEcom/wxSphShopBalanceList',
    method: 'post',
    data
  });
}

// 商品
export function checkContrabandApi(data) {
  return request({
    baseURL: '/steward/core/',
    url: '/kCodeApply/checkContraband?searchItem='+data,
    method: 'get',
  });
}
